import React, {
  useRef,
  useState,
  useEffect,
  createContext,
  useMemo,
  useCallback,
} from "react";
import RecruitmentListTemplate from "./components/templates/RecruitmentListTemplate";
import { useLocalStorage } from "../../hooks/localStrage";
import toISOStringWithTimezone from "../../functions/toISOStringWithTimezone";

export const recruitmentListContext = createContext();

// デフォルトの検索条件（当日と前月1日）を動的生成する関数
const createDefaultFormData = () => {
  const currentDay = new Date();
  const lastMonthDay = new Date(
    currentDay.getFullYear(),
    currentDay.getMonth() - 1,
    1
  );

  return {
    keyword: "",
    project_id: "",
    date_from: toISOStringWithTimezone(lastMonthDay).split("T")[0],
    date_to: toISOStringWithTimezone(currentDay).split("T")[0],
    offset: 0,
    cost_not_set: false,
    cost_min: "",
    cost_max: "",
    close_check: 1,
  };
};

export default function RecruitmentListPage() {
  const defaultFormData = useMemo(() => createDefaultFormData(), []);

  const [searchCondition, setSearchCondition] = useLocalStorage(
    "recuruitmentSearchCondition",
    defaultFormData
  );

  const [recruitmentList, setRecruitmentList] = useState([]);
  const [inputCostMinError, setInputCostMinError] = useState(false);
  const [inputCostMaxError, setInputCostMaxError] = useState(false);
  const [isMinCost, setIsMinCost] = useState(false);
  const [isMaxCost, setIsMaxCost] = useState(false);
  const inputCostMinRef = useRef(null);
  const inputCostMaxRef = useRef(null);
  const [postData, setPostData] = useState(null);
  const listInnerRef = useRef(null);
  const [isEndList, setIsEndList] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [isNotCostSet, setIsNotCostSet] = useState(false);

  useEffect(() => {
    // 金額設定のない要員を表示するかのチェックボックスのable/disableによりチェックを初期化
    if (!(isMinCost || isMaxCost)) {
      setIsNotCostSet(false);
    }
  }, [isMinCost, isMaxCost]);

  // 画面下部へのスクロールを検知（値に変化があった場合のみStateを更新）
  const onScroll = useCallback(() => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      const reachedBottom = scrollTop + clientHeight > scrollHeight - 10;
      setIsBottom((prev) => (prev !== reachedBottom ? reachedBottom : prev));
    }
  }, []);

  // Contextへ渡すオブジェクトをuseMemoでキャッシュ
  const values = useMemo(
    () => ({
      recruitmentList,
      setRecruitmentList,
      searchCondition,
      setSearchCondition,
      isBottom,
      setIsBottom,
      isEndList,
      setIsEndList,
      inputCostMinError,
      setInputCostMinError,
      inputCostMaxError,
      setInputCostMaxError,
      isMinCost,
      setIsMinCost,
      isMaxCost,
      setIsMaxCost,
      inputCostMinRef,
      inputCostMaxRef,
      postData,
      setPostData,
      isNotCostSet,
      setIsNotCostSet,
    }),
    [
      recruitmentList,
      searchCondition,
      setSearchCondition,
      isBottom,
      isEndList,
      inputCostMinError,
      inputCostMaxError,
      isMinCost,
      isMaxCost,
      postData,
      isNotCostSet,
    ]
  );

  return (
    <div
      onScroll={onScroll}
      ref={listInnerRef}
      style={{ height: "100vh", overflowY: "auto", overflowX: "hidden" }}
    >
      <recruitmentListContext.Provider value={values}>
        <RecruitmentListTemplate />
      </recruitmentListContext.Provider>
    </div>
  );
}